module.exports = __webpack_public_path__ + "static/media/EqualCost_02.1ed75311.svg";